import {commonAdminQueries} from '@common/admin/common-admin-queries';
import {queryFactoryHelpers} from '@common/http/queries-file-helpers';
import {queryOptions} from '@tanstack/react-query';
import {FileEntry} from '@common/uploads/file-entry';

const get = queryFactoryHelpers.get;
const paginate = queryFactoryHelpers.paginate;

export const adminQueries = {
  ...commonAdminQueries,
  deleteRequests: {
    invalidateKey: ['file-entries/delete-requests'],
    count: () =>
      queryOptions({
        queryKey: ['delete-requests', 'count'],
        queryFn: () =>
          get<{count: number}>('file-entries/delete-requests/count'),
      }),
    index: (search: Record<string, string> = {}) =>
      paginate<FileEntry>('file-entries/delete-requests', search) as ReturnType<
        typeof paginate<FileEntry>
      >,
  },
};
